import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDossier: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="dossier"><path d="M9.25 4.75V8.75H21.25M9.25 4.75H2.75V19.25H21.25V8.75M9.25 4.75H15.25M21.25 8.75V4.75H15.25M15.25 4.75V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDossier;
